/* What the console offers to whom. The API decides every request (requireAdmin, requireOperator,
 * row-level security); this only hides what would be refused, so nobody meets a dead end. Pure, so it
 * is unit-tested without a browser. */

export interface Viewer {
  role: 'admin' | 'member';
  isOperator: boolean;
}

export type Area =
  | 'home'
  | 'organizations'
  | 'buildings'
  | 'bookings'
  | 'users'
  | 'departments'
  | 'devices'
  | 'contracts'
  | 'integrations'
  | 'audit';

const ADMIN_AREAS: Area[] = [
  'home',
  'buildings',
  'bookings',
  'users',
  'departments',
  'devices',
  'contracts',
  'integrations',
  'audit',
];

/** Members have no business in the console; admins see their organization; operators everything. */
export function areasFor(viewer: Viewer): Area[] {
  if (viewer.isOperator) return ['home', 'organizations', ...ADMIN_AREAS.slice(1)];
  if (viewer.role === 'admin') return ADMIN_AREAS;
  return [];
}

export const canGrantOperator = (viewer: Viewer): boolean => viewer.isOperator;

/** Whether the viewer may change this user's access; the API refuses self-changes too. */
export const canEditUser = (viewer: Viewer & { id: string }, target: { id: string }): boolean =>
  viewer.id !== target.id && (viewer.isOperator || viewer.role === 'admin');
